import { render, staticRenderFns } from "./AllergenCard.vue?vue&type=template&id=2cc3a0f6&"
import script from "./AllergenCard.vue?vue&type=script&lang=js&"
export * from "./AllergenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports